export { default as Sidebar } from './main.vue';
